/* eslint-disable no-loop-func */
// import { FeedService } from '@pingum/api-services';
import HorseService from '../../services/HorseService';
import HorsePublicShareService from '../../services/HorsePublicShareService';
import * as types from './types';
import * as horseTypes from '../horse/types';
import {
  dispatchNetworkRequest,
  dispatchNetworkRequestDynamicSuccessDispatch,
} from '../networkDispatcher';

const previewableFileRegex = /.png|jpeg|jpg|gif$/;

function getPreviewLinks(note, horsePublicShareId, dispatch) {
  if (note.information && note.information.files && note.information.files.length > 0) {
    for (let j = 0; j < note.information.files.length; j += 1) {
      if (note.information.files[j].match(previewableFileRegex)) {
        const fileDownloadPromise = HorsePublicShareService.getHorseFile(horsePublicShareId, note.id, note.information.files[j]);
        fileDownloadPromise.then((download) => {
          const blob = new Blob([download], { type: 'application/octet-stream' });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            dispatch({
              type: horseTypes.SET_HORSE_FILE_PREVIEWS,
              noteId: note.id,
              file: note.information.files[j],
              base64data,
            });
          };
        });
      }
    }
  }
}

export const getHorsePublicShares = (horseId, page = 0, pageSize = 25, sort = '', search = '') => (dispatch) => {
  const promise = HorseService.getHorsePublicShares(horseId, page, pageSize, sort, search);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_HORSE_PUBLIC_SHARES_REQUESTED,
    successType: types.GET_HORSE_PUBLIC_SHARES_SUCCESS,
    errorType: types.GET_HORSE_PUBLIC_SHARES_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading share links for this horse',
    responseName: 'horsePublicShares',
  });
  return promise;
};

export const addHorsePublicShare = (horseId, request) => (dispatch) => {
  const promise = HorseService.addHorsePublicShare(horseId, request)
  dispatchNetworkRequest({
    dispatch,
    requestType: types.ADD_HORSE_PUBLIC_SHARE_REQUESTED,
    successType: types.ADD_HORSE_PUBLIC_SHARE_SUCCESS,
    errorType: types.ADD_HORSE_PUBLIC_SHARE_ERROR,
    promise,
    successMessage: 'Successfully created the sharing link',
    defaultErrorMessage: 'There was a problem adding the horse sharing link',
    responseName: 'newHorsePublicShare',
  });
  return promise;
};

export const updateHorsesPublicShare = (id, request) => (dispatch) => {
  const promise = HorsePublicShareService.updateHorsePublicShare(id, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.UPDATE_HORSE_PUBLIC_SHARE_REQUESTED,
    successType: types.UPDATE_HORSE_PUBLIC_SHARE_SUCCESS,
    errorType: types.UPDATE_HORSE_PUBLIC_SHARE_ERROR,
    promise,
    successMessage: 'Successfully updated the sharing link',
    defaultErrorMessage: 'There was a problem updating the sharing link',
    responseName: 'updatedHorsePublicShare',
  });
  return promise;
};

export const deleteHorsesPublicShare = (id) => (dispatch) => {
  const promise = HorsePublicShareService.deleteHorsePublicShare(id);
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: types.DELETE_HORSE_PUBLIC_SHARE_REQUESTED,
    successDispatch: {
      type: types.DELETE_HORSE_PUBLIC_SHARE_SUCCESS,
      deletedHorsePublicShareId: id,
    },
    errorType: types.DELETE_HORSE_PUBLIC_SHARE_ERROR,
    promise,
    successMessage: 'Successfully deleted the sharing link',
    defaultErrorMessage: 'There was a problem deleting the sharing link',
    responseName: 'response',
  });
  return promise;
};

export const getHorsesPublicShare = (id) => (dispatch) => {
  const promise = HorsePublicShareService.getHorsePublicShare(id);

  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_HORSE_PUBLIC_SHARE_FOR_HORSE_REQUESTED,
    successType: types.GET_HORSE_PUBLIC_SHARE_FOR_HORSE_SUCCESS,
    errorType: types.GET_HORSE_PUBLIC_SHARE_FOR_HORSE_ERROR,
    promise,
    successMessage: 'Successfully retrieved horse profile',
    defaultErrorMessage: 'There was a problem getting the horse profile information for this link',
    responseName: 'horsePublicShare',
  });

  promise.then((result) => {
    if (result.sharedNotes && result.sharedNotes.length > 0) {
      // for any notes with image files, get previews
      for (let i = 0; i < result.sharedNotes.length; i += 1) {
        getPreviewLinks(result.sharedNotes[i], id, dispatch);
      }
    }

    const notesByType = Object.keys(result.horseNotesByType)
      .filter((noteKey) => result.horseNotesByType[noteKey].length > 0)
    if (notesByType.length > 0) {
      for (let i = 0; i < notesByType.length; i += 1) {
        for (let j = 0; j < result.horseNotesByType[notesByType[i]].length; j += 1) {
          getPreviewLinks(result.horseNotesByType[notesByType[i]][j], id, dispatch);
        }
      }
    }
  });
  return promise;
};

